import React, { useCallback, useEffect, useState } from 'react';
import LaunchIcon from '@mui/icons-material/LaunchOutlined';
import { ButtonProps, styled } from '@mui/material';
import { defaultBorderRadius } from '../../../theme/components';
import { OnClickHandler } from '../../../types';
import { typographyThemeOptions } from '../../../theme/typography';
import OutlinedButton from '../OutlinedButton';
import { PatientElationLinkResponse, PatientService } from '../../../../core/services/patient.service';
import { Patient } from '@models';
import { Color } from '../../../theme/colors';

type ElationChartButtonProps = {
  buttonSize?: 'large' | 'medium' | 'small';
  displayPatientElationLink: boolean;
  patientElationLink: string | undefined;
} & ButtonProps;

export function ElationChartButton({
  buttonSize = 'small',
  displayPatientElationLink,
  patientElationLink,
  ...props
}: ElationChartButtonProps): React.JSX.Element {
  const onNavigateToChart: OnClickHandler = useCallback(() => {
    if (patientElationLink) {
      window.open(patientElationLink, '_blank');
    }
  }, [patientElationLink]);

  const StyledOutlinedButton = styled(OutlinedButton)(({ theme }) =>
    theme.unstable_sx({
      ...typographyThemeOptions.subtitle2,
      textWrap: 'nowrap',
      backgroundColor: Color.BaseGray,
      color: Color.Slate100,
      '&:hover': {
        backgroundColor: Color.BaseGray,
        color: Color.Slate100,
      },
      ...props.sx,
      radius: defaultBorderRadius,
      maxHeight: '38px',
    })
  );

  if (displayPatientElationLink) {
    return (
      <StyledOutlinedButton size={buttonSize} onClick={onNavigateToChart} endIcon={<LaunchIcon />}>
        Elation Chart
      </StyledOutlinedButton>
    );
  }

  return null;
}
export default ElationChartButton;
